import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    YES: {
        id: 'spareParts.priorityTreatment.option.yes',
        defaultMessage: 'Yes'
    },
    NO: {
        id: 'spareParts.priorityTreatment.option.no',
        defaultMessage: 'No'
    },
});

export default messages;
